import correiosImage from "../assets/logos/correios.svg";
import jadlogImage from "../assets/logos/jadlog.svg";
import beuniImage from "../assets/logos/beuni.png";
import braspressImage from "../assets/logos/braspress.png";
import empresacruzImage from "../assets/logos/empresacruz.png";

// Links saindo do betracking, com UTM pra saber de onde veio cada visita
// (Murilo, 20/10/2026: quem abre o rastreio é gente de fora da beuni, então a
// página também é vitrine). O lugar da página vai no utm_content.
//  - linkCadastro: os botões "Quero conhecer a beuni" levam direto pro
//    cadastro da plataforma, não pro site. O dashboard guarda a UTM da sessão
//    e manda como origem do lead (utility/marketing.js de lá).
//  - linkBeuni: o site, só no rodapé.
const UTM = "utm_source=betracking&utm_medium=link_rastreio&utm_campaign=rastreio";
export const linkCadastro = (lugar: string) => `https://dashboard.beuni.com.br/register?${UTM}&utm_content=${lugar}`;
export const linkBeuni = (lugar: string) => `https://beuni.com.br/?${UTM}&utm_content=${lugar}`;

export const trackingPatterns = {
  correios: /^[A-Z]{2}[0-9]{9}[A-Z]{2}$/,
  jadlog: /^[A-Z0-9]+$/,
  melhorEnvio: /^ME[A-Z0-9]+BR$/,
  beuni: /^BE[A-Z0-9]+BR$/,
};

export const trackingTypes = {
  correios: "Correios",
  jadlog: "Jadlog",
  melhorenvio: "Jadlog",
  beuni: "beuni",
  empresacruz: "Empresa Cruz",
  braspress: "Braspress",
  // Entrega ao vivo: motorista parceiro da beuni, acompanhado no mapa. O nome
  // da transportadora parceira nunca aparece pro cliente.
  ao_vivo: "Entrega ao vivo",
};

export const trackingTypeLogos = {
  correios: correiosImage,
  jadlog: jadlogImage,
  melhorenvio: jadlogImage,
  beuni: beuniImage,
  empresacruz: empresacruzImage,
  braspress: braspressImage,
  ao_vivo: beuniImage,
};
